import { FieldParams } from "../../core/FieldObject";
import { getCellStyle, GetHeaderStyle, PostJson } from "../../core/Helper";
import {
  FieldDataType,
  FormControlType,
  getDecimalString,
} from "../../core/Helper2";

export const CGDObj = (props) => {
  return {
    CgdId: {
      ...new FieldParams(
        "CgdId",
        "",
        true,
        FieldDataType.NUMERIC,
        FormControlType.HIDDEN
      ),
      isHiddenColumn: true,
    },
    CgdCode: {
      ...new FieldParams("CgdCode", "รหัสกรม"),
      defaultHeaderStyle: GetHeaderStyle("100px"),
    },
    CgdName: {
      ...new FieldParams("CgdName", "รายละเอียด"),
    },
    CgdPriceValue: {
      ...new FieldParams(
        "CgdPriceValue",
        "ราคากรม",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
      ),
      defaultHeaderStyle: GetHeaderStyle("100px"),
      defaultCellStyle: getCellStyle("right"),
      formatter: (cell, row) => getDecimalString(row?.CgdPriceValue, 0),
    },
  };
};

export class CGDService {
  static async GetList(data, user) {
    return (await PostJson("/api/cgd-price/getlist", { data, user })) ?? null;
  }

  static async GetItem(data, user) {
    let result = await PostJson("/api/cgd-price/getitem", {
      data,
      user,
    });
    return result ?? null;
  }

  static async SaveItem(data, user) {
    return (await PostJson("/api/cgd-price/update", { data, user })) ?? null;
  }

  static async DeleteItem(data, user) {
    return (
      (await PostJson("/api/cgd-price/delete", {
        data,
        user,
      })) ?? null
    );
  }
}
